import React, { useState } from "react";
import styles from "./index.module.css";
import addIcon from "../../assets/images/icons/add.png";
import closeIcon from "../../assets/images/icons/close-square.svg";
import userImg from "../../assets/images/user-img.png";
const AddedEvent = ({visible}) => {
  const [status, setStatus] = useState(true);
  const [age, setAge] = React.useState("");

  // const handleChange = (event) => {
  //   setAge(event.target.value);
  // };

  return (
    <>
      {/* <button onClick={() => setStatus(true)} className={styles.add_btn}>
        <img src={addIcon} alt="icon" />
        Создать новый
      </button> */}

      <div className={status ? "modal" : "modal_hiden_bg"}>
        <div className={status ? "modal_content" : "modal_hiden"}>
          <div className={styles.modal_header}>
            <h3 className={styles.modal_title}>Детали</h3>
            <button
              onClick={() => [setStatus(false), visible(false)]}
              className={styles.modal_close}
            >
              <img src={closeIcon} alt="closeIcon " />
            </button>
          </div>
          <div className={styles.modal_body}>
            <form className={styles.modal_form}>
              <div className="wrapper">
                <div className={styles.title_wrap}>
                  <h2 className={styles.title}>DDE Consulting</h2>
                  <h3 className={styles.sub_title}>65%</h3>
                </div>
                <div className={styles.date_container}>
                  <div className={styles.date_wrap}>
                    <h2 className={styles.date}>Дата старта:</h2>
                    <p className={styles.subdate}>05.11.2022</p>
                  </div>
                  <div className={styles.date_wrap}>
                    <h2 className={styles.date}>Дата окончания:</h2>
                    <p className={styles.subdate}>05.11.2022</p>
                  </div>
                </div>
                <div className={styles.participants}>
                  <h2 className={styles.p_title}>Участники</h2>

                  <div className={styles.user_card}>
                    <img className={styles.user_img} src={userImg} alt="" />
                    <h3 className={styles.p_subtitle}>Жасур Туляганов</h3>
                  </div>
                  <div className={styles.user_card}>
                    <img className={styles.user_img} src={userImg} alt="" />
                    <h3 className={styles.p_subtitle}>Жасур Туляганов</h3>
                  </div>
                  <div className={styles.user_card}>
                    <img className={styles.user_img} src={userImg} alt="" />
                    <h3 className={styles.p_subtitle}>Жасур Туляганов</h3>
                  </div>
                  <div className={styles.user_card}>
                    <img className={styles.user_img} src={userImg} alt="" />
                    <h3 className={styles.p_subtitle}>Жасур Туляганов</h3>
                  </div>

                  <div className={styles.description}>
                    <h2 className={styles.d_title}>Описание проекта</h2>
                    <p className={styles.d_subtitle}>
                      Java — язык программирования на базе синтаксиса C и C++.
                      Впервые его концепцию представила «Зелёная команда»,
                      подразделение Sun Microsystems, во главе с Джеймсом
                      Гослингом. Разработчики делали язык простым, но
                      многопоточным, независимым от платформы и защищённым. <br />
                       Java — объектно-ориентированный язык, он организовывает работу
                      вокруг объектов, а не функций и логики. Мобильные
                      приложения, в том числе и научные, игры, программные
                      инструменты, всемирно известные Amazon, Spotify,
                      Minecraft, базируются на Java.
                    </p>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div className={styles.modal_footer}>
            <button
              onClick={() => setStatus(false)}
              type={"submit"}
              className={styles.save_btn}
            >
              Сохранить
            </button>
            <button className={styles.cancel_btn}>Отмена</button>
          </div>
        </div>
      </div>
    </>
  );
};
export default AddedEvent;
